<template>
  <div
    :class="[$style.container, page === 'home' ? $style.home : $style.result]"
  >
    <Title
      v-if="page == 'home'"
      title="查询，轻松找到你的专属域名"
      size="large"
    />

    <!-- 输入框 -->
    <div :class="$style.textarea">
      <el-input
        v-model="text"
        type="textarea"
        placeholder="请输入域名，每行一个域名；支持字符为英文、数字、中文、“-”；每次最多支持500个，多出部分将被忽略；"
        :autosize="{ minRows: 3, maxRows: 10 }"
        @keyup.32.native="onKeyupSpace"
      />
      <div :class="$style.textarea_count">
        {{ `${getDomainNames().length}/500` }}
      </div>
    </div>

    <!-- 快捷选项选择 -->
    <Row :class="$style.actions">
      <el-radio-group v-model="radio" @change="handleRadioChange">
        <el-radio :label="1">全选</el-radio>
        <el-radio :label="2">全不选</el-radio>
        <el-radio :label="3">常用</el-radio>
      </el-radio-group>

      <Button type="primary" :loading="loading" @click="clickSearch">
        <i v-if="!loading" class="el-icon-search" />
        &nbsp; 查域名
      </Button>
    </Row>

    <!-- 选项 -->
    <el-checkbox-group v-model="checkFixList">
      <template v-for="(item, index) in fixList">
        <div :key="index" :class="$style.domain_item">
          <el-checkbox :label="item.domainSuffix">{{
            item.domainSuffix
          }}</el-checkbox>
        </div>
      </template>
    </el-checkbox-group>
  </div>
</template>

<script>
import { mapMutations,mapState } from "vuex";

import { getDomainSuffix, getDomainCheck, getSensitiveWords } from "@server";

export default {
  name: "Search",
  props: {
    page: {
      // home - 域名注册首页 ，result - 域名结果页
      type: String,
      default: "home",
    },
    domainText: {
      type: String,
      default: "",
    },
    domainSuffix: {
      type: [Array, String],
      default: () => [],
    }
  },
  data() {
    return {
      // isLogin: false,
      text: "",

      searchValue: "", // 搜索值
      radio: 3, // 快捷选项选择
      fixList: [], // 域名后缀列表
      checkFixList: [], // 已选后缀
      loading: false,
      sensitiveWordsList:[],
      isShow:false
    };
  },
  async created() {
    if(this.page == 'result'){
      if(this.sensitiveWords.length <= 0){
        this.getSensitiveWordsList()
      }else{
        this.sensitiveWordsList = this.sensitiveWords;
        this.initText();
      }
    }else{
      this.initText();
    }
    await this.getDomainSuffix();

  },
  methods: {
    ...mapState(['sensitiveWords']),
    ...mapMutations(["setDomainText", "setDomainSuffix",'setSensitiveWords']),
    initText() {
      // 对域名查询结果页的text，使用域名首页的text初始化
      if (this.page === "home") return;
      this.text = this.domainText;
      this.checkFixList = this.domainSuffix;
      this.setDomainText("");
      let nameList = this.text.split('\n')
      nameList.forEach(item=>{
        this.sensitiveWordsList.forEach(val=>{
          if(item.toLowerCase().indexOf(val.toLowerCase()) !== -1){
            this.isShow = true;
            return
          }
        })
      })
      this.fetchData();

    },

    async getDomainSuffix() {
      const res = await getDomainSuffix();
      const { code, data } = res;
      if (code === 200) {
        this.fixList = data;
        if (this.page == "home") {
          this.checkFixList = this.fixList
            .filter((item) => item.isSelected === 1)
            .map((item) => item.domainSuffix);
        } else if (this.domainSuffix) {
          this.domainSuffix.map((item) => {
            let list = {
              domainSuffix: item.domainSuffix,
              isSelected: 1,
            };
            this.checkFixList.push(list);
          });
        }
      }
    },

    async getSensitiveWordsList(){
      const res = await getSensitiveWords()
      if(res.code === 200){
        this.setSensitiveWords(res.data)
        this.sensitiveWordsList= res.data
         this.initText();
      }
    },

    async fetchData() {
      const textArr = this.getDomainNames(this.text);
      this.text = textArr.join("\n");

      if (textArr.length === 0) return;

      this.loading = true;
      this.$emit("loading", true);

      const promise = [];

      this.checkFixList.forEach((fix) => {
        const data = {
          domainNameList: textArr.map((item) => item + fix),
          domainSuffix: fix,
        };
        promise.push(getDomainCheck(data));
      });

      const res = await Promise.all(promise);

      let list = [];
      res.forEach((item) => {
        if (item.code === 200) {
          list.push(...item.data);
        }
      });

      list = list.sort((a, b) => a.registerStatus - b.registerStatus);

      this.$emit("fetchSuccess", list);
      this.$emit("loading", false);
      this.$emit("isShow", this.isShow);
      this.loading = false;
    },

    getDomainNames() {
      // 域名字符串转数组，去空行、去字间空格、去重
      let textArr = this.text
        .split("\n")
        .filter((i) => !!i)
        .map((i) => i.replace(/\s+/g, ""));
      textArr = [...new Set(textArr)];
      return textArr;
    },

    onKeyupSpace() {
      this.text = this.text.trim(); // 清除空格效果
    },

    clickSearch() {
      if (!this.text) {
        this.$message({ message: "请输入域名", type: "warning" });
        return;
      }
      this.config = false
      this.page === "home" ? this.toResult() : this.toSearch();
    },

    toResult() {
      this.setDomainText(this.text);
      this.setDomainSuffix(this.checkFixList);
      // this.$router.push("/dSearch");
      this.$router.push({
        path: "/dSearch",
        query: { text: this.text,checkFixList:JSON.stringify(this.checkFixList)},
      })
    },

    toSearch() {
      this.isShow = false;
      let nameList = this.text.split('\n')
      nameList.forEach(item=>{
        this.sensitiveWordsList.forEach(val=>{
          if(item.toLowerCase().indexOf(val.toLowerCase()) !== -1){
            this.isShow = true;
            return
          }
        })
      })

      this.fetchData();

    },

    handleRadioChange(val) {
      switch (val) {
        case 1:
          this.checkFixList = this.fixList.map((item) => item.domainSuffix);
          break;
        case 2:
          this.checkFixList = [];
          break;
        case 3:
          this.checkFixList = this.fixList
            .filter((item) => item.isSelected == 1)
            .map((item) => item.domainSuffix);
          break;
      }
    },
  },


};
</script>

<style lang="scss" module scoped>
.container {
  box-sizing: border-box;
  width: rem(1200);
  min-width: 620px;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0px 7px 38px 0px rgba(2, 2, 2, 0.05);

  &.home {
    margin: rem(-171) auto 0;
    padding: rem(20) rem(60);
  }

  &.result {
    margin: 0 auto rem(20);
    padding: rem(40) rem(60);
  }

  :global {
    ::v-deep .el-textarea {
      .el-textarea__inner {
        padding: 20px;
      }
    }

    .gl-button {
      margin: 0;
    }

    .el-radio-group {
      height: rem(75);
      display: flex;
      align-items: center;
    }

    ::v-deep .el-checkbox-group {
      margin-top: rem(60);
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .el-checkbox {
        .el-checkbox__input {
          .el-checkbox__inner {
            border-radius: 50%;
          }
        }

        .el-checkbox__label {
          font-size: rem(16);
          @include text-ellipsis(rem(120));
        }
      }
    }
  }

  .textarea {
    position: relative;
    .textarea_count {
      position: absolute;
      right: 20px;
      bottom: 20px;
      font-size: 14px;
      color: #898989;
    }
  }

  .actions {
    display: flex;
    justify-content: space-between;
    padding: rem(20) 0;
    border-bottom: $border-1;
  }

  .domain_item {
    width: 140px;
    margin-bottom: 40px;
  }
}
</style>

